module.exports = __webpack_public_path__ + "static/media/home-left.879145b2.webp";